module.exports = __webpack_public_path__ + "img/0023.cf06f851.jpg";